import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const solutions = ['Organizar tu negocio para vender por internet con una estrategia más clara.', 'Crear anuncios pensados para atraer consultas reales, incluso con presupuestos bajos.', 'Usar inteligencia artificial para escribir anuncios, respuestas y contenido en menos tiempo.', 'Responder mejor por WhatsApp y aumentar tus chances de cerrar ventas.', 'Entender cuánto invertir, cómo medir resultados, y qué ajustar.', 'Implementar un plan concreto para empezar a moverte más rápido, incluso si arrancás desde cero.'];
export function SolutionSection() {
  return <section className="py-10 sm:py-20 px-4" data-id="element-211">
      <div className="max-w-4xl mx-auto" data-id="element-212">
        <motion.div initial={{
        opacity: 0,
        y: 5
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-10px'
      }} transition={{
        duration: 0.2
      }} data-id="element-213">
          <div className="text-center mb-8 sm:mb-12" data-id="element-214">
            <div className="inline-block bg-green-800/40 p-3 rounded-full mb-4" data-id="element-215">
              <span className="text-3xl" data-id="element-216">💡</span>
            </div>
            <h2 className="text-3xl sm:text-4xl font-black text-white drop-shadow-lg uppercase" data-id="element-217">
              CON EL MÉTODO VENTA FLASH IA VAS A PODER:
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-218">
            {solutions.map((solution, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-20px'
          }} transition={{
            duration: 0.2,
            delay: index * 0.05
          }} className="flex items-start gap-4 bg-green-900/40 p-6 rounded-2xl border border-green-600/20 hover:bg-green-900/60 transition-colors" data-id="element-219">
                <div className="bg-yellow-300 rounded-full p-1 shrink-0" data-id="element-220">
                  <CheckCircle2 className="w-6 h-6 text-green-900" data-id="element-221" />
                </div>
                <p className="text-lg text-white font-medium leading-snug" data-id="element-222">
                  {solution}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}